/*
  groom.bg filter clean-up (snippets/list-filter.liquid, snippets/filter-remove-buttons.liquid).
  Equivalent spellings of a value ("473ml", "473 ml", "473 мл") render as one checkbox plus hidden
  alias inputs in the same list item; the coat type filter adds "всички типове" as an alias of every coat. Capture-phase listeners run before Horizon's handlers:
  - a checkbox change copies its state to the aliases, so the query keeps every spelling;
  - a remove pill for a merged value gets a data-url without any of its spellings.
*/
(() => {
  if (window.groomFilters) return;
  window.groomFilters = true;

  // a checkbox's click event fires (already toggled) before its change event, so syncing on
  // click as well guarantees the aliases are set before Horizon reads the form
  // An alias is wanted when the visible checkbox of any list item that carries it is checked. The
  // coat filter's "всички типове" alias sits in every coat item, so only one copy is checked to
  // keep a single URL parameter.
  const recompute = (scope) => {
    const groups = new Map();
    scope.querySelectorAll('input[data-g-alias]').forEach((alias) => {
      const k = alias.name + '\u0000' + alias.value;
      if (!groups.has(k)) groups.set(k, []);
      groups.get(k).push(alias);
    });
    groups.forEach((aliases) => {
      const wanted = aliases.some((alias) => {
        const main = alias.closest('li')?.querySelector('input[type="checkbox"]:not([data-g-alias])');
        return !!(main && main.checked);
      });
      aliases.forEach((alias, i) => { alias.checked = wanted && i === 0; });
    });
  };
  const sync = (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'checkbox' || input.hasAttribute('data-g-alias')) return;
    const item = input.closest('li');
    if (!item || !item.querySelector('input[data-g-alias]')) return;
    recompute(input.closest('facet-inputs-component') || input.closest('form') || document);
  };
  document.addEventListener('click', sync, true);
  document.addEventListener('change', sync, true);

  // pills toggle on Enter/Space in Horizon's own keydown handler (no change event), which runs
  // after this capture listener: set the aliases to the state the pill is about to get
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const wrap = event.target instanceof Element ? event.target.closest('.facets__pill-wrapper') : null;
    const item = wrap && wrap.closest('li');
    if (!item || !item.querySelector('input[data-g-alias]')) return;
    const main = wrap.querySelector('input[type="checkbox"]');
    if (main) item.querySelectorAll('input[data-g-alias]').forEach((a) => { a.checked = !main.checked; });
  }, true);

  // Horizon reads data-url in its own click handler (registered before this script), so the URL
  // is prepared ahead of time: on render, and again on pointerdown/focus in case the URL changed.
  const rewrite = (pill) => {
    let pairs;
    try { pairs = JSON.parse(pill.getAttribute('data-g-remove')); } catch (e) { return; }
    const params = new URLSearchParams(window.location.search);
    pairs.forEach(([name, value]) => params.delete(name, value));
    params.delete('page');
    const query = params.toString();
    pill.dataset.url = window.location.pathname + (query ? '?' + query : '');
  };
  const rewriteAll = () => document.querySelectorAll('[data-g-remove]').forEach(rewrite);
  const near = (event) => {
    const pill = event.target instanceof Element ? event.target.closest('[data-g-remove]') : null;
    if (pill) rewrite(pill);
  };
  document.addEventListener('pointerdown', near, true);
  document.addEventListener('focusin', near, true);
  new MutationObserver(rewriteAll).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rewriteAll, { once: true });
  else rewriteAll();
})();
